import PromotionList from './PromotionList';

export default PromotionList;
